export const VIEW_FINDER_ENABLED_SINCE = "2026-07-01"